import { DESCRIBED_BY } from '../../constants/a11y'

const ERROR = 'error'

const getErrorAriaText = id => `${id}__${ERROR}`

export const setAccessibleErrorText = formEl =>
  formEl.setAttribute(DESCRIBED_BY, getErrorAriaText(formEl.getAttribute('id')))

export const unsetAccessibleErrorText = formEl => formEl.setAttribute(DESCRIBED_BY, '')
